import { ReadFile } from '@paragon/client-tools';
import { Lumber, LumberGrade, LumberPrice, LumberSpecies, LumberTreatmentType } from '@paragon/contract-library';

import { DesignService } from '../connections';

export function getAllLumberPrices() {
  return DesignService.get<readonly LumberPrice[]>('public/lumberPrices');
}

export function getMostRecentLumberPrices(lumber: Lumber) {
  return DesignService.get<readonly LumberPrice[]>('public/lumberPrices/mostRecent', {
    params: new URLSearchParams({
      nominalThicknessInInches: lumber.nominalThickness,
      nominalWidthInInches: lumber.nominalWidth,
      grade: lumber.grade,
      species: lumber.species,
      treatmentType: lumber.treatmentType,
    }),
  });
}

export interface LumberPriceEdit {
  readonly guid: string;
  readonly pricePerThousandBoardFeet: number;
  readonly notes: string | null;
}

export function editLumberPrices(edits: readonly LumberPriceEdit[]) {
  return DesignService.put<readonly LumberPrice[]>('public/lumberPrices/bulk', { data: edits });
}

export interface NewLumberPrice {
  readonly pricePerThousandBoardFeet: number;
  readonly nominalThicknessInInches: number;
  readonly nominalWidthInInches: number;
  readonly lengthInInches: number;
  readonly grade: LumberGrade;
  readonly species: LumberSpecies;
  readonly treatmentType: LumberTreatmentType;
  readonly notes: string | null;
}

export function postLumberPrice(newLumberPrice: NewLumberPrice) {
  return DesignService.post<LumberPrice>('public/lumberPrices', { data: newLumberPrice });
}

export function importLumberPrices(file: ReadFile) {
  return DesignService.post<readonly LumberPrice[]>('lumberPrices/importLumberPrices', { data: file });
}

export function exportLumberPrices() {
  return DesignService.fetchFile('lumberPrices/exportLumberPrices');
}
